import * as C from "../constants/aboutConstants";
import api from "../utils/axiosInstance";
import { getApiErrorMessage } from "../utils/errorMessages";

/**
 * Public
 * GET /api/about
 */
export const getAbout = () => async (dispatch) => {
  try {
    dispatch({ type: C.ABOUT_DETAILS_REQUEST });

    const { data } = await api.get("/about");

    dispatch({
      type: C.ABOUT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: C.ABOUT_DETAILS_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not load the about page right now. Please try again later.",
      }),
    });
  }
};

/**
 * Admin
 * GET /api/about/admin
 */
export const getAboutAdmin = () => async (dispatch) => {
  try {
    dispatch({ type: C.ABOUT_ADMIN_DETAILS_REQUEST });

    const { data } = await api.get("/about/admin");

    dispatch({
      type: C.ABOUT_ADMIN_DETAILS_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const payload = getApiErrorMessage(error, {
      fallback:
        "We could not load about page content right now. Please try again later.",
    });

    dispatch({
      type: C.ABOUT_ADMIN_DETAILS_FAIL,
      payload,
    });

    throw new Error(payload);
  }
};

/**
 * Admin
 * PUT /api/about/admin
 */
export const updateAbout = (aboutData) => async (dispatch) => {
  try {
    dispatch({ type: C.ABOUT_UPDATE_REQUEST });

    const { data } = await api.put("/about/admin", aboutData);

    dispatch({
      type: C.ABOUT_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: C.ABOUT_UPDATE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not update the about page right now. Please try again later.",
      }),
    });
  }
};

/**
 * Admin
 * DELETE /api/about/admin
 */
export const deleteAbout = () => async (dispatch) => {
  try {
    dispatch({ type: C.ABOUT_DELETE_REQUEST });

    const { data } = await api.delete("/about/admin");

    dispatch({
      type: C.ABOUT_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: C.ABOUT_DELETE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not delete the about page right now. Please try again later.",
      }),
    });
  }
};
